/**
 * Standardiserade CTA:er för hela sajten.
 * Använd dessa konstanter överallt istället för att skriva egen text.
 */
export const FREE_CTA = {
  label: "Testa provet gratis nu",
  labelKey: "cta.free",
  to: "/gratis-alkoholprov" as const,
};

export const PREMIUM_CTA = {
  label: "Klara provet – kom igång från 199 kr",
  labelKey: "cta.premium",
  to: "/pricing" as const,
};
